import styled from 'styled-components';
import { Box } from '@mui/material';

export const QuoteDetailsSection = styled(Box)`
.totalRow
{
    background-color: #BDD0E9;
    font-weight:700;
}
    border: 1px solid #1B4A83;
    border-radius: 0px 0px 5px 5px;
    border-top: 5px solid rgb(27, 74, 131);
    padding: 0px 30px 30px 30px;
    .quotedetailWrapper{
       
           thead{
      background-color: #1B4A83;
    tr{
          th{
              color: #fff;
              font-weight: 600;
          }
          .taskrow{
            background-color:#BDD0E9;
            color: #1b4a83;
        }
      }
   }
   .accordianmain{
    min-height:38px !important;
    height:38px;
    
    background-color: rgb(27, 74, 131);
    color: rgb(255, 255, 255);
    border-radius: 3px;
    
    }
    .accordianheading{
        width: 30% !important;
        font-size: 14px;
        font-weight: 600;
        text-align:center;
       
        button
        { 
            font-size: 14px;
            font-weight: 600;
            text-align:center;
            color:#1B4A83;
        }
    }
    .countryaccordian{
        min-height:50px !important;
        height:50px;
        color: rgb(255, 255, 255);
        border-radius: 3px;
        background-color: #3C74C7;
    }
    .countrybox
    {
        border:1px solid #1B4A83;
        padding:20px;
        .detailaccordian{
            min-height:50px !important;
            height:50px;
            color: #000000;
            border-radius: 3px;
            background-color: #BDD0E9;
        }
    }
   .accordionWrapper{
       padding: 20px;
   .accordianTop{
       background-color: #3C74C7;

   }

   }
   .MuiAccordionSummary-content{
       justify-content: space-between;
   }
   .accordian p{
        width: 12%;
   }
   .accordianFirst{
    margin-bottom:10px;
       .accordian{
        min-height:50px !important;
        height:50px;
        margin-bottom:20px;
         background-color: #BDD0E9;
         color: #000000;
         svg{
            color:#1B4A83;
         }
        .title4{
            color:#1B4A83;
            svg{
 color:#1B4A83;
     font-size: 16px;
    margin: -4px 5px;
            }
        }

       }
       .customerStatus{
        display: flex;
        width: 100%;
        border: 1px solid #1B4A83;
        border-radius: 5px;
        justify-content: space-between; 
        .d-flex{
            width:100%;
            
            flex-wrap: no-wrap;
            .customerDetails{
                width: 15%;
                .contentUser{
                    h4{
                    color: #080909;
                    font-size: 16px;
                    font-weight:700;
                }

                .txtUtilization{
                    height: 18px;
                }
            }
         }
         .customerDetailstwo{
            width: 20%;
            .contentUser{
                h4{
                color: #080909;
                font-size: 16px;
                font-weight:700;
            }
        }
     }
    }
}
.tablewrapper{
    display:flex;
    justify-content: space-between;
        margin-top: 40px;
    .tableRight{
        width: 47%;
        border:1px solid #1B4A83;
        border-radius:5px;
        height: fit-content;
    }
    .tableLeft{
        width: 47%;
        height: fit-content;
        border:1px solid #1B4A83;
        border-radius:5px;
    }
}
.sessionTable{
      margin-top: 40px;
      border:1px solid #1B4A83;
        border-radius:5px;
}
.distributionTable{
     margin-top: 40px;
     border:1px solid #1B4A83;
     border-radius:5px;
     
     .utilizationStatus {
        display: flex;
        border: 1px solid #1b4a83;
        justify-content: space-between;
        .d-flex {
          width: 100%;
      
          flex-wrap: no-wrap;
          .customerDetails {
            width: 30%;
            margin:30px 30px 10px 30px;
            .formdata {
              width: 100%;
              text-align: start;
              min-height: 120px;
      
              label {
                font-size: 14px;
                color: #1B4A83;
                font-weight: 700;
                padding-left: 3px;
              }
              .formInputTwo {
                margin-top: 16px;
                width: 90%;
                font-size: 14px;
                margin: 16px 0 0 0;
                .MuiInputBase-input {
                  height: 0.4375em;
                  background-color: #fff;
                  font-weight:700;
                  color:black;
                  border-radius: 5px;
                  
                }
                .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
                    opacity: 1;
                    -webkit-text-fill-color: black;
                }
              }
            }
          }
        }
      }
      

     
     .tableFooter{
         display: flex;
         background-color: #BDD0E9;
         color: #000000;
         font-weight: 600;
         .footer-text-1{
             padding: 16px;
             text-align: start;
             width:11%;
         }
                  .footer-text-2{
             padding: 16px;
             text-align: start;
         }
     }
}
.priceTable{
      margin-top: 40px;
      border:1px solid #1B4A83;
      border-radius:5px;
      caption{
          color: #1B4A83;
          font-weight: 600;
          span{
              padding-left: 20px;
          }
      }
}


   }
    }
span.error {
    color: #d32f2f;
    line-height: 2;
    font-weight: 400;
}
span.red {
    color: #ff0000;
}
.errorInput {
    border: 1px solid #ff0000;
    border-radius: 5px;


  }

  .correctInput {
    border: 1px solid black;
    border-radius: 5px;
  }
  .paginationContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h6 {
      color: #1b4a83;
      font-weight: 600;
      font-family: "Noto Sans", sans-serif;
      span {
        font-size: 14px;
        font-weight: 500;
        color: #000;
        padding-left: 6px;
        font-family: "Noto Sans", sans-serif;
      }
    }
    button {
      margin: 10px 0;
      border-radius: 2px;
      font-family: "Noto Sans", sans-serif;
    }
  }
`;